import React from 'react';

import type { PointGetCardsFilters } from '@vlabs/api/types';
import { CardsFiltersProvider } from '@vlabs/monokit/entities/cards/filters/useCardsFilters';
import { FilterMenuProvider } from '@vlabs/monokit/shared/ui/filter-menu';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { PageFilters } from '@vlabs/monokit/shared/ui/page/PageFilters';
import { DEFAULT_PAGE_SIZE } from '@vlabs/uikit/constants';

import { ListDetailsFilterMenu } from './filters';
import { ListDetailsPageContent } from './page-content';
import { useListIdFromLocation } from './useListIdFromLocation';

const cardListDefaultFilters: PointGetCardsFilters = {
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
  sort: 'create_time',
  order: 'desc',
};

export function ListDetailsPage(): React.JSX.Element {
  const listId = useListIdFromLocation();
  return (
    <Page>
      <CardsFiltersProvider
        initialData={{
          ...cardListDefaultFilters,
          list_ids: [listId],
        }}
      >
        <FilterMenuProvider>
          <PageContent>
            <ListDetailsPageContent />
          </PageContent>

          <PageFilters>
            <ListDetailsFilterMenu />
          </PageFilters>
        </FilterMenuProvider>
      </CardsFiltersProvider>
    </Page>
  );
}
